module.exports = __webpack_public_path__ + "media/start_page10.b28e25f5.mp3";